"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noFactors = 'Good news! There were no noticeable factors to deduct from this score.';
exports.factorDescriptionsByScore = {
  quiet: {
    air_traffic: 'Proximity to aircraft traffic',
    bar: 'Proximity to bars/pubs',
    biergarten: 'Proximity to bars/pubs',
    bridleway: 'Proximity to equestrian trails',
    cafe: 'Proximity to cafes',
    cycleway: 'Proximity to bicycle lanes/paths',
    cycleway_tunnel: 'Proximity to underground bicycle lanes/paths',
    disused: 'Proximity to unused roads',
    disused_tunnel: 'Proximity to unused road tunnels',
    fast_food: 'Proximity to fast-food eateries',
    fire_station: 'Proximity to fire stations',
    footway: 'Proximity to walking paths',
    footway_tunnel: 'Proximity to walking path tunnels',
    groyne: 'Proximity to wave-braking structures',
    groyne_tunnel: 'Proximity to underground wave-braking structures',
    hospital: 'Proximity to hospitals',
    light_rail: 'Proximity to light rail',
    light_rail_tunnel: 'Proximity to underground light rail',
    living_street: 'Proximity to high-foot-traffic streets',
    living_street_tunnel: 'Proximity to high-foot-traffic tunnels',
    monorail: 'Proximity to monorails',
    monorail_tunnel: 'Proximity to underground monorails',
    motorway: 'Proximity to major highways',
    motorway_tunnel: 'Proximity to major underground highways',
    motorway_link: 'Proximity to highway on-ramps/connectors',
    motorway_link_tunnel: 'Proximity to underground highway on-ramps/connectors',
    narrow_gauge: 'Proximity to railway',
    narrow_gauge_tunnel: 'Proximity to underground railway',
    path: 'Proximity to walking paths',
    path_tunnel: 'Proximity to walking path tunnelsProximity to walking paths',
    pedestrian: 'Proximity to pedestrian roads',
    pedestrian_tunnel: 'Proximity to pedestrian tunnels',
    pier: 'Proximity to piers',
    pier_tunnel: 'Proximity to pier tunnels',
    police: 'Proximity to police stations',
    preserved: 'Proximity to historical railroad tracks',
    primary: 'Proximity to major local roads',
    primary_tunnel: 'Proximity to major underground local roads',
    primary_link: 'Proximity to major linking roads',
    primary_link_tunnel: 'Proximity to major underground linking roads',
    pub: 'Proximity to bars/pubs',
    raceway: 'Proximity to racetracks',
    rail: 'Proximity to major railway',
    rail_tunnel: 'Proximity to major underground railway',
    rail_xing: 'Proximity to railroad crossings',
    residential: 'Density of nearby residential roads',
    residential_tunnel: 'Density of nearby residential road tunnels',
    restaurant: 'Proximity to nearby restaurants',
    road: 'Density of nearby roads',
    road_tunnel: 'Density of nearby road tunnels',
    secondary: 'Proximity to secondary roads',
    secondary_tunnel: 'Proximity to underground secondary roads',
    secondary_link: 'Proximity to connectors between major roads',
    secondary_link_tunnel: 'Proximity to underground connectors between major roads',
    service: 'Proximity to service access roads',
    service_tunnel: 'Proximity to underground service access roads',
    steps: 'Proximity to flights of steps on walking paths',
    steps_tunnel: 'Proximity to flights of steps on underground walking paths',
    subway: 'Proximity to subways',
    subway_tunnel: 'Proximity to subway tunnels',
    tertiary: 'Density of nearby minor/local roads',
    tertiary_tunnel: 'Density of nearby minor/local road tunnels',
    tertiary_link: 'Proximity to connectors between minor roads',
    tertiary_link_tunnel: 'Proximity to underground connectors between minor roads',
    track: 'Density of nearby back/country roads',
    track_tunnel: 'Density of nearby back/country road tunnels',
    tram: 'Proximity to street-level trains/trams',
    tram_tunnel: 'Proximity to tunnels for street-level trains/trams',
    trunk: 'Proximity to major high-traffic roads',
    trunk_tunnel: 'Proximity to underground major high-traffic roads',
    trunk_link: 'Proximity to connectors between major high-traffic roads',
    trunk_link_tunnel: 'Proximity to underground connectors between major high-traffic roads',
    unclassified: 'Density of nearby minor residential roads',
    unclassified_tunnel: 'Density of nearby minor residential road tunnels'
  },
  safety: {
    accel: 'Frequency of hard vehicle braking or acceleration',
    speed: 'Frequency of high vehicle speeds'
  },
  errand: {
    bank: 'Low density of nearby banks/ATMs',
    barber_or_salon: 'Low density of nearby hairdressers',
    day_care: 'Low density of nearby day care/babysitting',
    healthcare_dentist: 'Low density of nearby dentists',
    healthcare_physician: 'Low density of nearby physicians',
    laundry: 'Low density of nearby laundry/dry-cleaning',
    pet_care: 'Low density of nearby pet-care shops',
    retail_alcohol: 'Low density of nearby liquor stores',
    retail_alchohol: 'Low density of nearby liquor stores',
    retail_appliances: 'Low density of nearby appliance stores',
    retail_convenience: 'Low density of nearby convenience stores',
    retail_food: 'Low density of nearby small food stores',
    retail_gas: 'Low density of nearby gas stations',
    retail_grocery: 'Low density of nearby grocery stores',
    retail_hardware: 'Low density of nearby hardware stores',
    retail_home_goods: 'Low density of nearby home goods stores',
    retail_general: 'Low density of nearby big-box stores',
    retail_pharmacy: 'Low density of nearby pharmacies',
    school: 'Low density of nearby schools',
    wholesale_goods: 'Low density of nearby wholesale stores'
  },
  entertainment: {
    bar: 'Low density of nearby bars/nightclubs',
    brewery: 'Low density of nearby breweries/wineries',
    movie_theater: 'Low density of nearby movie theaters',
    recreation_amusement: 'Low density of nearby amusement parks',
    recreation_park: 'Low density of nearby parks',
    recreation_sports: 'Low density of nearby recreational sports (golf, batting cages, etc.)',
    restaurant: 'Low density of nearby restaurants',
    retail_clothing: 'Low density of nearby clothing stores'
  },
  traffic: {
    highway: 'Traffic congestion on highways',
    local_primary_roads: 'Traffic congestion on primary roads',
    local_secondary_roads: 'Traffic congestion on local secondary roads'
  }
};